import { Box, Typography } from '@mui/material';
import { IncentivioRouteObject } from 'pages/main-routes';
import { useMemo } from 'react';
import { useMatches } from 'react-router-dom';

type IncPageTitleProps = {
  children?: React.ReactNode;
  'data-testid'?: string;
  icon?: any;
  sx?: object;
};

const IncPageTitle = ({
  children,
  'data-testid': dataTestId = 'IncPageTitle',
  icon,
  sx,
  ...rest
}: IncPageTitleProps) => {
  const matches = useMatches();
  const routeTitle = useMemo(() => {
    // Looking at the last two because of index routes
    const lastTwo = matches.slice(-2);
    return (
      (lastTwo.at(-1) as IncentivioRouteObject)?.handle?.page?.title() ??
      (lastTwo.at(-2) as IncentivioRouteObject)?.handle?.page?.title()
    );
  }, [matches]);

  return (
    <Typography
      variant="h1"
      sx={{ display: 'flex', alignItems: 'center', ...sx }}
      data-testid={dataTestId}
      {...rest}
    >
      {icon && (
        <Box
          display="flex"
          alignItems="center"
          mr={1}
          data-testid={`${dataTestId}.Icon`}
        >
          {icon}
        </Box>
      )}
      {children ? children : routeTitle}
    </Typography>
  );
};

export default IncPageTitle;
